exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.step-bar[data-v-7689656e]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:15px\n}\n.step-bar__step[data-v-7689656e]{-webkit-box-flex:1;-ms-flex:1;flex:1;height:4px;background-color:#d1d1d1;border-radius:16px\n}\n.step-bar__step--active[data-v-7689656e]{background-color:#0093d6\n}\n.step-heading[data-v-7689656e]{margin:0;font-size:15px;color:#0093d6;font-weight:600;margin-bottom:12px\n}\n.step-heading__container[data-v-7689656e]{margin-top:37px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7689656e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/cms-content-slices/components/clean-air-zone/Navigation.vue
// module id = UqYh
// module chunks = 32